import { GenericModelApi } from "./GenericModelApi";
import { ApiClient, ApiError, ApiSchema, FetchResponse } from "./ApiClient";
import { BuyInvoicePaymentFormData, BuyInvoicePaymentRelatedAttributes } from "@/formTypes/BuyInvoicePaymentDataType";
import { BuyInvoicePaymentFormDataKeys } from "@/generated/BuyInvoicePaymentFormDataKeys";

export type BuyInvoicePaymentDataType = Partial<ApiSchema["BuyInvoicePayment"]["type"] & BuyInvoicePaymentFormData>;
class Api extends GenericModelApi<"BuyInvoicePayment", BuyInvoicePaymentDataType> {

    async fetchAllByBuyInvoice(buyInvoiceId: string): Promise<FetchResponse<BuyInvoicePaymentDataType>> {
        const fetchFunction = ApiClient.models[this.modelName].listBuyInvoicePaymentByInvoiceIdTenant;

        const selectionSet = [
            ...BuyInvoicePaymentFormDataKeys.filter(k => !BuyInvoicePaymentRelatedAttributes.includes(k)),
            "currency.*",
        ]

        const { data, errors, nextToken: nt } = await fetchFunction({
            buyInvoiceId: buyInvoiceId
        }, {
            limit: 1000,
            selectionSet
        });

        if (errors) {
            throw new ApiError("Error al obtener los abonos de factura de compra", "API_ERROR", errors);
        }

        return { items: data };
    }

    async fetchAllByRecibe(recibeId: string): Promise<FetchResponse<BuyInvoicePaymentDataType>> {
        const fetchFunction = ApiClient.models[this.modelName].listBuyInvoicePaymentByProviderRecibeId;

        const { data, errors, nextToken: nt } = await fetchFunction({
            providerRecibeId: recibeId
        }, {
            limit: 1000
        });

        if (errors) {
            throw new ApiError("Error al obtener los abonos de factura de compra por recibo", "API_ERROR", errors);
        }

        return { items: data };
    }

}
export const BuyInvoicePaymentApi = new Api("BuyInvoicePayment", "descripcion")